import { useState } from "react";
import DiscreetMessage from "./DiscreetMessage";
import Section from "./Section";

type EntityBase = {
  uuid: string;
};
type ConditionalProps<P> = {} extends P ? { props?: P } : { props: P };
type CardProps<T extends EntityBase, P = {}> = {
  entity: T;
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
  props: P;
};

type EntityListProps<T extends EntityBase, P = {}> = {
  entities: T[] | null;
  Card: React.ComponentType<CardProps<T, P>>;
  props?: P;
} & ConditionalProps<P>;
const EntityList = <T extends EntityBase, P = {}>({
  entities,
  Card,
  props,
}: EntityListProps<T, P>) => {
  const [expanded, setExpanded] = useState<string | null>(null);
  return (
    <Section className="p-4 flex flex-col gap-4 pb-32">
      {!entities && <DiscreetMessage text="Carregando ..." />}

      {entities && entities.length === 0 && (
        <DiscreetMessage text="Nenhum resultado" />
      )}

      {entities &&
        entities.length > 0 &&
        entities.map((entity) => (
          <Card
            key={entity.uuid}
            entity={entity}
            expanded={expanded === entity.uuid}
            setExpanded={(expanded: boolean) =>
              expanded ? setExpanded(entity.uuid) : setExpanded(null)
            }
            props={props as P}
          />
        ))}
    </Section>
  );
};

export default EntityList;
